import { CollapsableCard } from '@eogile/agrements-common/src/components/card/CollapsableCard';
import { Form } from 'react-final-form';
import { Grid } from '@mui/material';
import FormFiltersListener from '@eogile/agrements-common/src/form/components/FormFiltersListener';
import { formValuesToQueryString } from '@eogile/agrements-common/src/utils/tableUtils';
import TextFieldAdapter from '@eogile/agrements-common/src/form/components/TextFieldAdapter';
import { EnumSelectAdapter } from '@eogile/agrements-common/src/form/components/EnumSelectAdapter';
import React, { useMemo } from 'react';
import { SocieteMereUsersFilterValues } from '../societeMereUsersTypes';
import { SocieteMereUserProfile } from '../../societeMereUserTypes';
import { societeMereProfileDisplayLabels } from '../../societeMereUserUtils';
import { hasAtLeastOneFilterValue } from '@eogile/agrements-common/src/utils/filtersUtils';

type Props = {
  filterValues: SocieteMereUsersFilterValues;
};

/**
 * Component in charge of displaying the filters and updating
 * the query string when values change.
 */
const SocieteMereUsersFilters = ({ filterValues }: Props) => {
  const defaultOpened = useMemo(() => hasAtLeastOneFilterValue(filterValues), [filterValues]);
  return (
    <CollapsableCard defaultOpened={defaultOpened} title="Critères">
      <Form initialValues={filterValues} onSubmit={() => {}}>
        {() => (
          <Grid container columnSpacing={2}>
            <FormFiltersListener transformValues={formValuesToQueryString(filterValues)} />
            <Grid item container sm={6} xs={12} rowSpacing={2}>
              <Grid item xs={12}>
                <TextFieldAdapter name="login" label="Login" />
              </Grid>
              <Grid item xs={12}>
                <TextFieldAdapter name="lastName" label="Nom" />
              </Grid>
            </Grid>
            <Grid item container sm={6} xs={12} rowSpacing={2} alignContent="flex-start">
              <Grid item xs={12}>
                <TextFieldAdapter name="email" label="Email" />
              </Grid>
              <Grid item xs={12}>
                <EnumSelectAdapter
                  label="Rôle"
                  name="profile"
                  options={Object.values(SocieteMereUserProfile)}
                  optionName={(profileCode) => societeMereProfileDisplayLabels[profileCode]}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Form>
    </CollapsableCard>
  );
};

export default SocieteMereUsersFilters;
